import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class NpsUtilsService {

  getNpsStatus(nps: number): string {
    if (nps > 65) return 'qualifys.excellent';
    if (nps >= 50) return 'qualifys.good';
    if (nps >= 35) return 'qualifys.regular';
    if (nps >= 20) return 'qualifys.bad';
    return 'qualifys.very_bad';
  }
}
